<template>
  <div class="instructions clear">
    <div class="left">
      <span>填表说明：</span>
    </div>
    <div class="right">
      <p v-for="(item, index) in instructionsList" :key="index">{{ item }}</p>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "instructions",
  props: {
    instructionsList: {
      type: Array,
    },
  },
};
</script>

<style lang="less" scoped>
.clear:after {
  content: '';
  height: 0;
  line-height: 0;
  display: block;
  visibility: hidden;
  clear: both;
}

.instructions {
  font-size: 12px;
  color: #7c7c7c;
  .left {
    min-width: 60px;
    float: left;
  }

  .right {
    margin-left: 60px;
  }

}
</style>